/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Storage_Notice_StrongInputs */



/**
* | output |
* | --- |
* | "Files are permanently removed after 14 days." |
*
* @param {Embed_Captions_Storage_Notice_StrongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_storage_notice_strong = /** @type {((inputs?: Embed_Captions_Storage_Notice_StrongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Storage_Notice_StrongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les fichiers sont definitivement supprimes apres 14 jours.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Dateien werden nach 14 Tagen endgültig gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I file vengono rimossi definitivamente dopo 14 giorni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файлы удаляются безвозвратно через 14 дней.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los archivos se eliminan de forma permanente después de 14 días.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件将在 14 天后永久删除。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルは 14 日後に完全に削除されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फाइलें 14 दिनों के बाद स्थायी रूप से हटा दी जाती हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os arquivos são removidos permanentemente após 14 dias.")
	return /** @type {LocalizedString} */ ("Files are permanently removed after 14 days.")
});